import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import AuthContext from '../contexts/AuthContext';
import { relativeTime } from '../utils/relativeTime';

export default function SettingsPage() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [scheduler, setScheduler] = useState(null);
  const [error, setError] = useState('');

  const username = localStorage.getItem('username') || '—';
  const role = localStorage.getItem('role') || '—';

  useEffect(() => {
    let mounted = true;
    api.get('/api/health')
      .then((resp) => { if (mounted) setScheduler(resp.data.scheduler); })
      .catch(() => { if (mounted) setError('Health endpoint unreachable.'); });
    return () => { mounted = false; };
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const lastTick = scheduler?.lastTickAt ? relativeTime(scheduler.lastTickAt) : null;

  return (
    <div>
      <h1 className="text-[22px] font-bold tracking-tight mb-4">Settings</h1>

      <section className="bg-surface-panel border border-surface-border p-[18px] mb-3">
        <div className="text-[10px] font-bold uppercase tracking-[0.08em] text-surface-muted mb-3">Profile</div>
        <div className="grid grid-cols-[140px_1fr] gap-4 text-xs mb-3">
          <div className="text-surface-muted">Username</div>
          <div className="text-surface-text">{username}</div>
          <div className="text-surface-muted">Role</div>
          <div className="text-accent">{role}</div>
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="px-[14px] py-2 bg-transparent text-steam-danger border border-steam-danger text-[11px] font-bold uppercase tracking-wider rounded-[2px]"
        >Log out</button>
      </section>

      <section className="bg-surface-panel border border-surface-border p-[18px]">
        <div className="text-[10px] font-bold uppercase tracking-[0.08em] text-surface-muted mb-3">System</div>
        {error && <div className="text-steam-danger text-xs">{error}</div>}
        {scheduler && (
          <div className="grid grid-cols-[180px_1fr] gap-4 text-xs">
            <div className="text-surface-muted">Cooldown scheduler</div>
            <div>
              {scheduler.running
                ? <><span className="text-steam-success">● Running</span> <span className="text-surface-muted">· last tick {lastTick?.relative || 'never'}</span></>
                : <span className="text-steam-danger">● Stopped</span>}
            </div>
            <div className="text-surface-muted">Tick interval</div>
            <div className="text-surface-text">{Math.round(scheduler.tickIntervalMs / 60000)} minutes</div>
            <div className="text-surface-muted">Eligible accounts</div>
            <div className="text-surface-text">
              {scheduler.eligibleCount} of {scheduler.totalCredentialed}{' '}
              <span className="text-surface-muted">
                ({scheduler.skipped?.banned ?? 0} banned · {scheduler.skipped?.cooldown ?? 0} in cooldown · {scheduler.skipped?.quarantined ?? 0} quarantined)
              </span>
            </div>
            <div className="text-surface-muted">Failure thresholds</div>
            <div className="text-surface-text">
              {scheduler.failureAlertThreshold} for alert · {scheduler.quarantineThreshold} for quarantine
            </div>
          </div>
        )}
      </section>

      <p className="text-[11px] text-surface-muted mt-3">
        Tunables (tick interval, thresholds, webhook URL) can be added here as separate sections when we need them.
      </p>
    </div>
  );
}
